
  <!-- content begin -->
  <div id="content" class="no-bottom no-top">
    <div id="top"></div>


  <!-- section begin -->
  <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)" data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; " >
    <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <h1>About the post</h1>
                </div>
            </div>
        </div>

    </div>

</section>
<!-- section close -->



<div class="row notifi_main ">
  <div class="col-md-12">
<h2>
    Senior Programmer / Full-Stack Developer
</h2>


  </div>
</div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
    <div class="col-md-12">
      <div class="row sequence">


        <!-- feature box begin -->
        <div class="col-md-12 mb40 sq-item wow sq-item wow">
            <div class="feature-box style-2 left">
              <i class="fa fa-graduation-cap"></i>
              <div class="text para_cls">
                <h3>Qualification & Experience: </h3>
                <p> <span class="step_no">1</span> Regular B.E/ B. Tech / M. Tech / BSC / MSc / MCA degree in Computer Science / Information Technology / Electronics and Communication Engineering or any degree with specialization in computers or equivalent with minimum 5+ years of system development experience.
				</p>
               
              
  
              </div>
            </div>
          </div>
          <!-- feature box close -->
  
       
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Preferred:</h3>
        <p> <span class="step_no">1</span>Experience in designing and implementing of software systems in JavaScript, AngularJS, SaaS solutions and services.</p>
		<p> <span class="step_no">2</span>Full Stack development experience.</p>
        <p> <span class="step_no">3</span>Hands on experience in Laravel.</p>
		<!--<p> <span class="step_no">4</span>Experience in Designing Logical / Physical Data Models and create Physical Databases for the Software Development Projects</p>
		<p> <span class="step_no">5</span>Experience in developing Functions and Triggers</p>
		<p> <span class="step_no">6</span>Experience in Management Information Systems (MIS)</p>-->
		
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-history"></i>
      <div class="text para_cls">
        <h3>Technologies:</h3>
        <p> <span class="step_no">1</span> Node JS / LARAVEL, Angular / React JS 
            Web Development: HTML5, CSS3, JavaScript, SASS/LESS, jQuery, Bootstrap
            </p>
		<p> <span class="step_no">2</span> Web Services: REST, SOAP</p>
        <p> <span class="step_no">3</span> Application Design: Model-View-Controller (MVC/MVC2), Object Oriented Programming.
            Database: MySQL, Maria DB, Mongo DB.
            Strong in C++, JavaScript. 
            </p>
		<p> <span class="step_no">4</span> Experience working with agile methodologies.</p>
        <!--<p> <span class="step_no">5</span> Experience in working with agile methodologies. </p>-->
       </div>
    </div>
  </div>
  <!-- feature box close -->

  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Remuneration:</h3>
        <p> <span class="step_no">1</span> Rs. 70000 to 80000 per month (consolidated pay) </p>
		<!--<p> <span class="step_no">2</span> Rs. 45,000/- per month (consolidated pay) for 3+ Experience from which standard TDS will be deducted at source. Not entitled to any other allowance or benefits.  </p>-->


      </div>
    </div>
  </div>
  <!-- feature box close -->

   <!-- feature box begin -->
   <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Responsibilities:</h3>
        <p> <span class="step_no">1</span> Developing front end website architecture.</p>
        <p> <span class="step_no">2</span> Designing user interactions on web pages.  </p>
        <p> <span class="step_no">3</span> Developing back-end website applications</p>
        <p> <span class="step_no">4</span> Creating servers and databases for functionality.</p>
        <p> <span class="step_no">5</span> Ensuring cross-platform optimization for mobile phones. </p>
		<p> <span class="step_no">6</span> Ensuring responsiveness of applications.</p>
        <p> <span class="step_no">7</span> Designing and developing APIs.</p>
        <p> <span class="step_no">8</span> Staying abreast of developments in web applications and programming languages. </p> 
        <p> <span class="step_no">9</span> Build web-based and mobile-first front-end GUIs to support workflows.</p>
        <p> <span class="step_no">10</span> Integrate with REST APIs and relational databases.</p>		
		<p> <span class="step_no">11</span> Design and implement low-latency, high-availability, and performance applications.</p>
        <p> <span class="step_no">12</span> Help define architectures and design patterns..</p>
<!--<p> <span class="step_no">13</span>Protecting data by developing data security and restoration policies, procedures, and controls.</p>
<p> <span class="step_no">14</span>Knowledge of best practices in database management.</p>
<p> <span class="step_no">15</span>Advanced analytical, leadership, and problem-solving skills.</p>-->



      </div>
    </div>
  </div>
  <!-- feature box close -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-money"></i>
      <div class="text para_cls">
        <h3>Skills & Requirements</h3>
        <p> <span class="step_no">1</span> Hands on experience in Core PHP, Laravel/ Node JS.</p>
        <p> <span class="step_no">2</span> Familiarity with node.js server environment.
            Familiarity with JavaScript frameworks such as Node JS / Angular
             </p>
        <p> <span class="step_no">3</span> Familiarity with database technology such as MySQL and MongoDB.</p>
        <p> <span class="step_no">4</span> Experience with HTML5 CSS3 frameworks such as bootstrap.</p>
        <p> <span class="step_no">5</span> Experience with web services API integration (Rest, JSON, XML). </p>
		<p> <span class="step_no">6</span> Solid & deep understanding of the full web technology stack (e.g. HTTP, cookies, headers, caching, asset pipelines)</p>
        <p> <span class="step_no">7</span> Solid understanding of version control systems such as Git and bitbucket</p>
        <p> <span class="step_no">8</span> Experience using different development methodologies including Scrum, and/or Agile, and test-driven development </p> 
        <p> <span class="step_no">9</span> Disciplined approach to software engineering best practices (e.g. unit testing, code reviews, design documentation, quality assurance)</p>
        <p> <span class="step_no">10</span> Must be experienced with Payment Gateway integrations.</p>		
		<!--<p> <span class="step_no">11</span> Design and implement low-latency, high-availability, and performance applications.</p>
        <p> <span class="step_no">12</span> Help define architectures and design patterns..</p>-->
<!--<p> <span class="step_no">13</span>Protecting data by developing data security and restoration policies, procedures, and controls.</p>
<p> <span class="step_no">14</span>Knowledge of best practices in database management.</p>
<p> <span class="step_no">15</span>Advanced analytical, leadership, and problem-solving skills.</p>-->



      </div>
    </div>
  </div>
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-calendar"></i>
      <div class="text para_cls">
        <h3>Last Date:</h3>
        <p style="color: red;"><b> Last date for Applying Online 09th July 2022 </b> </p>
      </div>
    </div>
  </div>
  <!-- feature box close -->

    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Locations</h3>
        <p><span class="step_no">1</span>Chennai</p>
		
	
		
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Selection Process:</h3>
        <p><span class="step_no">1</span>Selection will be done on the basis of performance in the personal interview by a selection committee.</p>
		<p><span class="step_no">2</span>Only shortlisted candidates will be called for the interview.</p>
		<p><span class="step_no">3</span>No TA/DA will be paid for attending the interview.</p>
<p><span class="step_no">4</span>At the time of the interview, the candidates shall produce their original certificates for verification. </p>

      </div>
    </div>
  </div>
  <!-- feature box close -->
  
     <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Attendance and leave policy:</h3>
        <p><span class="step_no">1</span>The working hours will be the same as for NIMI.</p>
		<p><span class="step_no">2</span>No extra remuneration shall be paid for working beyond office hours or on Saturdays/Sundays/gazetted holidays.</p>
		<p><span class="step_no">3</span>Compulsory leave in such cases shall be at the discretion of the competent authority. </p>


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
    <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Confidentiality and secrecy :</h3>
        <p><span class="step_no">1</span>The consultant maintain confidentiality and will not divulge any information gathered during the period of engagement with the NIMI to any person who is not authorised to know the same. </p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
   <!-- feature box begin -->
  <div class="col-md-12 feature-box mb40 sq-item wow">
    <div class="feature-box style-2 left">
      <i class="fa fa-globe"></i>
      <div class="text para_cls">
        <h3>Documents for attending the Test and Interview :</h3>
        <p><span class="step_no">1</span>2 copies of passport size photographs</p>
		<p><span class="step_no">2</span>Original and self attested copies of educational certificates</p>
		<p><span class="step_no">3</span>Original and self attested copies of  Caste certificate  and Aadhar card</p>
		<p><span class="step_no">4</span>Original  and self attested copies of Experience certificates</p>
		


      </div>
    </div>
  </div>
  <!-- feature box close -->
  
  
<!--
  <div class="col-md-12 feature-box mb40 sq-item wow" style="text-align: center;">
    <a href="http://nimiprojects.in/recruitment/register.php" target="_blank" class="btn-custom scroll-to">Apply Now</a>
</div> -->


  <div class="container big_padd">








      </div>


    </div>
    <!-- content close -->




    <style>
      #section-intro{
        background-image: url(assets/images/background/niminew.jpg);
    background-size: cover;
    background-position: 0% 0px;
    height: 80vh !important;
      }
      .notifi_main{
        text-align: center;
        padding: 40px 0px;
      }

      .notifi_main h2{
        border-bottom: 6px solid #F56B55;
    width: fit-content;
    margin: 0 auto;
    padding: 0px 30px;
      }
      .notifi_main .descrip_cls{
        padding: 5px 0px;
    font-weight: 500;
    font-size: 21px;
      }

      .overlay-bg.t50{
        background: rgba(30, 30, 30, .1);
      }

      table{
      width: 100%;
      margin-top: 10px;
    }
    th, td{
      padding: 10px;
    }
    thead{
      background-color: #F56B55;
      color: #fff;
    }
    tr:nth-child(odd){
      background-color: #eee;
    }
    .step_no{
      left: 80px;
    height: 30px;
    width: 30px;
    background-color: #F56B55;
    border-radius: 50%;
    display: inline-block;
    font-size: 18px;
    text-align: center;
    color: #fff;
    margin-right: 10px;
    position: absolute;
    }

    .para_cls p{
      padding-left: 35px;
    }
    .num_marks{
      text-align: center;
    }
    .last_tr{
      background-color: #F56B55 !important;
      color: #fff;
    }
    .notifi_main_table h2{

    width: fit-content;
    margin: 0 auto;
    padding: 50px 30px 10px;
    font-size: 23px;

    }
    .para_main_notify{
      padding: 20px 0px;
    width: 50%;
    margin: 0 auto;
    }
  #section-services{
      padding: 0px !important;
    }
    </style>
